/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-11 14:48:40
 *
 *******************************************************/
// @flow

export const DIRECTION = [{ label: '<=>', value: '<=>' }, { label: '=>', value: '=>' }];

// Display 10 suggestions per page
export const NUMBER_SYNONYMS_PER_PAGE = 10;

export const SynonymType = {
  MANUAL: 'synonym',
  AI: 'ai-synonym'
}
